// What the user picked in the appearance menu. `system` follows the PC's own light/dark setting.
//
// ⚠️ These values are STORED - in the `theme` user preference and in localStorage - so renaming one
// silently resets every user who had it. The same three strings are read by the inline script in
// each app's index.html, which applies the appearance before the stylesheet paints.
export enum ThemeMode {
  light = 'Light',
  dark = 'Dark',
  system = 'System',
}
